import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { CapVersionPageModule } from '@cengage/cap-version-page-lib-react';
import { CapEnvironmentModule } from '@cengage/cap-portal-environment-lib-react';
import { CapApiModule } from '@cengage/cap-portal-api-lib-react';
import { CapAuthenticationModule } from '@cengage/cap-portal-authentication-lib-react';

import { ErrorServiceProvider } from './services/error.service';
import { CoreDataServiceProvider } from './services/portal-core-data/portal-core-data.service';
import { ClientInteractionServiceProvider } from './services/cap-client-interaction.service';
import { AlertServiceProvider } from './services/alert.service';
import { ManifestServiceProvider } from './services/manifest.service';
import { CafeEventingModule } from './services/cafe.service';

import { VERSION } from '../environments/version';
import { environmentOptions, cafeOptions } from './app.constants';
import { composeProviders } from './shared/utils';

export function AppModule({ children }: React.PropsWithChildren) {
  const Providers = React.useMemo(
    () =>
      composeProviders(
        <BrowserRouter />,
        <CapVersionPageModule version={VERSION} />,
        <CapEnvironmentModule environmentOptions={environmentOptions} />,
        <CapApiModule />,
        <CapAuthenticationModule />,
        <CafeEventingModule options={cafeOptions} />,
        <AlertServiceProvider />,
        <ErrorServiceProvider />,
        <ManifestServiceProvider />,
        <CoreDataServiceProvider />,
        <ClientInteractionServiceProvider />
      ),
    []
  );

  return <Providers>{children}</Providers>;
}
